import { Model } from '@vuex-orm/core';

export default class Feature extends Model {
  static entity = 'features';

  static fields() {
    return {
      name: this.string(''),
      isEnabled: this.boolean(false)
    };
  }
}
